import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';

const DayPicker = ({ 
  value, 
  onChange, 
  label = "Select Day", 
  fullWidth = true, 
  variant = "outlined",
  disabled = false,
  error = false,
  helperText = "",
  id = "day-picker"
}) => {
  // Generate array of days 1-31
  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <FormControl 
      fullWidth={fullWidth} 
      variant={variant}
      disabled={disabled}
      error={error}
    >
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        value={value || ''}
        label={label}
        onChange={handleChange}
      >
        {days.map((day) => (
          <MenuItem key={day} value={day}>
            {day}
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <div style={{ 
          fontSize: '0.75rem', 
          color: error ? '#f44336' : '#666', 
          marginTop: '3px', 
          marginLeft: '14px' 
        }}>
          {helperText}
        </div>
      )}
    </FormControl>
  );
};

DayPicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  label: PropTypes.string,
  fullWidth: PropTypes.bool,
  variant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  id: PropTypes.string,
};

export default DayPicker;